import React from 'react'
import styled, { css } from 'react-emotion'
import { NavLink } from 'react-router-dom'
import { fontWeight, spacer, withTheme, color, typography } from 'stylist'

const activeClassName = theme => css`
  && {
    ${fontWeight('bold', { theme })};
    color: ${color('ink', { theme })};
  }
`

const NavItemLink = styled(NavLink)`
  display: grid;
  grid-template-columns: 40px 1fr;
  align-items: center;
  color: ${color('pewter')};
  padding: ${spacer(3)} 0;

  &:hover {
    color: ${color('ink')};
  }
`

const NavItemLabel = styled.span`
  padding-left: ${spacer(2)};
  ${typography('subheading2')};
`

const NavItemIcon = styled.span`
  justify-self: center;
`

const NavItem = ({ to, renderIcon, label, theme }) => (
  <NavItemLink activeClassName={activeClassName(theme)} to={to}>
    <NavItemIcon>{renderIcon()}</NavItemIcon>
    <NavItemLabel>{label}</NavItemLabel>
  </NavItemLink>
)

export default withTheme(NavItem)



// WEBPACK FOOTER //
// ./src/components/Sidebar/NavItem.js